package org.vreo.devicehub.features.core.domain.device.device

import kotlinx.serialization.Serializable

/**
 * Device authentication model, assists presentation layer to authenticate device if access is required.
 * Mainly to be used by ViewModels
 *
 * @property userToken User authentication token
 * @property deviceId Target device ID
 * @property isDeviceActive Whether the device is active or not
 */
@Serializable
data class DeviceAuthentication(
    val userToken: String,
    val deviceId: String,
    val isDeviceActive: Boolean
)
